/**
 * Groepeer ongeplande werkbonnen op plaats voor de Te plannen-drawer.
 */

export const NO_ADDRESS_GROUP_KEY = '__no_address';
export const NO_ADDRESS_GROUP_LABEL = 'Zonder adres';

export function getWorkOrderAddress(workOrder) {
  return workOrder?.installation_address || workOrder?.project?.installation_address || null;
}

export function hasCompleteAddress(workOrder) {
  const addr = getWorkOrderAddress(workOrder);
  return !!(addr?.street && addr?.city);
}

export function getPostalCode(workOrder) {
  const addr = getWorkOrderAddress(workOrder);
  return String(addr?.postal_code || addr?.postalCode || '').trim();
}

export function getCustomerName(workOrder) {
  return (workOrder?.project?.lead?.name || '').trim();
}

export function getStreetLabel(workOrder) {
  const addr = getWorkOrderAddress(workOrder);
  if (!addr) return '';
  return [addr.street, addr.house_number || addr.houseNumber].filter(Boolean).join(' ');
}

export function getCityGroup(workOrder) {
  const addr = getWorkOrderAddress(workOrder);
  const city = (addr?.city || '').trim();
  if (city) {
    return {
      key: `city:${city.toLowerCase()}`,
      label: city,
      sort: city.toLowerCase(),
    };
  }

  const postal = getPostalCode(workOrder);
  const digits = postal.match(/^(\d{4})/);
  if (digits) {
    return { key: `pc:${digits[1]}`, label: digits[1], sort: digits[1] };
  }
  if (postal) {
    return { key: `pc:${postal.toLowerCase()}`, label: postal, sort: postal.toLowerCase() };
  }

  return {
    key: NO_ADDRESS_GROUP_KEY,
    label: NO_ADDRESS_GROUP_LABEL,
    sort: 'ÿ',
  };
}

export function formatPlanningDuration(minutes) {
  const value = Number(minutes) || 120;
  const hours = Math.floor(value / 60);
  const mins = value % 60;
  if (hours && mins) return `${hours}u ${mins}m`;
  if (hours) return `${hours}u`;
  return `${mins}m`;
}

export function getWorkOrderDurationMinutes(workOrder) {
  return Number(workOrder?.appointment_duration_minutes) || 120;
}

export function groupWorkOrdersByCity(workOrders) {
  const map = new Map();

  (workOrders || []).forEach((wo) => {
    const group = getCityGroup(wo);
    if (!map.has(group.key)) {
      map.set(group.key, {
        key: group.key,
        label: group.label,
        sort: group.sort,
        missingAddress: group.key === NO_ADDRESS_GROUP_KEY,
        workOrders: [],
      });
    }
    map.get(group.key).workOrders.push(wo);
  });

  const groups = [...map.values()].sort((a, b) => {
    if (a.key === NO_ADDRESS_GROUP_KEY) return 1;
    if (b.key === NO_ADDRESS_GROUP_KEY) return -1;
    return a.sort.localeCompare(b.sort, 'nl');
  });

  groups.forEach((group) => {
    group.workOrders.sort((a, b) => {
      const postalCmp = getPostalCode(a).localeCompare(getPostalCode(b), 'nl');
      if (postalCmp) return postalCmp;
      return String(a.work_order_number || '').localeCompare(
        String(b.work_order_number || ''),
        'nl'
      );
    });
    group.totalDuration = group.workOrders.reduce(
      (sum, wo) => sum + getWorkOrderDurationMinutes(wo),
      0
    );
  });

  return groups;
}
